export default "__VITE_PUBLIC_ASSET__bbb6131e__"